import script from "./EButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./EButton.vue?vue&type=script&lang=ts&setup=true"

import "./EButton.vue?vue&type=style&index=0&id=285134e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-285134e8"]])

export default __exports__